import {ITariffVariant} from 'entities/tariff';
import {OptionType} from 'shared/model/types';

export const TARIFF_VARIANT_TARIFF_PARAM = 'tariff.id';
export const TARIFF_VARIANT_PERIOD_PARAM = 'period';

export function filterTariffVariants(items: ITariffVariant[], params: URLSearchParams): ITariffVariant[] {
    const tariffId = params.get(TARIFF_VARIANT_TARIFF_PARAM);
    const period = params.get(TARIFF_VARIANT_PERIOD_PARAM);

    return items.filter(item =>
        (!tariffId || item.tariffs.some(tariff => String(tariff.id) === tariffId))
        && (!period || String(item.period) === period),
    );
}

export function getTariffVariantTariffOptions(items: ITariffVariant[], archiveSuffix: string): OptionType[] {
    const tariffs = new Map<number, string>();
    items.forEach(item => item.tariffs.forEach(tariff => {
        tariffs.set(tariff.id, `${tariff.name}${tariff.is_archive ? archiveSuffix : ''}`);
    }));

    return Array.from(tariffs, ([id, label]) => ({label, value: String(id)}));
}

export function getTariffVariantPeriodOptions(items: ITariffVariant[]): OptionType[] {
    return Array.from(new Set(items.map(item => item.period)))
        .sort((a, b) => a - b)
        .map(period => ({label: String(period), value: String(period)}));
}
